// extracted by mini-css-extract-plugin
export default {"errorMsg":"DisputeAuthorization_errorMsg__tTWUk"};